export default __webpack_public_path__ + "b04ad446b6dc5207028012cd35e2a0ee.svg";